import * as yup from 'yup';

export const InvoiceAllocationInputSchema = yup.object({
    allocationAmount: yup
        .number()
        .notOneOf([0], 'Amount should not be 0')
        .typeError('Enter Valid Amount')
        .required('Amount is required')
        .test('is-valid-decimal', 'Invalid decimals in amount', value => {
            return (value + '').match(/^\d*\.{1}\d{3,}$/g) === null;
        })
});
